import WhatsAppIcon from "./WhatsAppIcon";
import { WA_FLOAT } from "../data/content";

export default function FloatingWhatsApp() {
    return (
        <a
            data-testid="whatsapp-floating-btn"
            href={WA_FLOAT}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            className="md:hidden fixed bottom-5 right-5 z-40 flex items-center justify-center h-12 w-12 rounded-full bg-forest text-cream shadow-lg shadow-navy/30 border border-gold/40 transition-transform duration-300 hover:scale-105 active:scale-95"
        >
            <WhatsAppIcon size={24} />
            <span className="absolute inset-0 rounded-full border border-forest/50 animate-ping opacity-30" aria-hidden="true" />
        </a>
    );
}
